@if (parentMenuComponent.markSelected) {
  <div class="selected-marker">
    @if (parentMenuComponent.value === value) {
      <ppl-icon
        svgIcon="checkmark-toggle"
        width="14px"
        height="14px"></ppl-icon>
    }
  </div>
}
@if (parentMenuComponent.hasIcons) {
  <div class="option-icon">
    <ng-content select="ppl-icon"></ng-content>
    @if (pplIconTemplate) {
      <ng-container *ngTemplateOutlet="pplIconTemplate"></ng-container>
    }
  </div>
}
<div class="content">
  <ng-content></ng-content>
</div>
<ng-content select="extra-content"></ng-content>
@if (parentMenuComponent.hasChildren) {
  <div class="option-children">
    @if (hasChildren) {
      <svg
        width="6px"
        height="12px">
        <path
          d="M0,0 l6,6 l-6,6 Z"
          fill="#03273f"></path>
      </svg>
    }
  </div>
}
